import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Categories, Devices} from "./userSlice";
import {orignalURI} from "../../http-common";


export interface User{
    id : number,
    first_name: string,
    last_name : string,
    email : string,
    dob : string,
    userID : string
}

const user : User | null = JSON.parse(localStorage.getItem('user')!)
    ||
    null

const token : string | null = localStorage.getItem('token')

const role :  string  = localStorage.getItem('user_role')|| ''

const url :  string  = 'https://pkdservers.com/RPM-Super/api'

export const authSlice = createSlice({
    name: 'auth',
    initialState:{
        user : user,
        token : token,
        role : role,
        url: url
    },
    reducers: {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes

        initializeUser: (state,action:PayloadAction<User>) => {
            state.user = action.payload
        },
        updateUser: (state,action:PayloadAction<User>) => {
            state.user = action.payload
        },
        initializeToken(state,action:PayloadAction<string>){
            state.token = action.payload
        },
        initializeRole(state,action:PayloadAction<string>){
            state.role = action.payload
        },
        initializeUrl(state,action:PayloadAction<string>){
            state.url = action.payload
        },
        resetAuth(state){
            state.role = ''
            state.user = null
            state.token = null
            state.url = orignalURI
        }
    },
})

// Action creators are generated for each case reducer function
export const {
    initializeUser,
    initializeRole,
    initializeToken,
    updateUser,
    resetAuth,
    initializeUrl
} = authSlice.actions

export default authSlice.reducer